import React, {Component} from 'react';
import SimpleAreaChart from './SimpleAreaChart';
import SimpleBarChart from './SimpleBarChart';
import SimplePieChart from './SimplePieChart';

class ChartsExample extends React.Component {
    render() {
        return (
            <div>
                <div className="row">
                    <div className="col-md-6">
                        <SimpleAreaChart/>
                    </div>
                    <div className="col-md-6">
                        <SimpleBarChart/>
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-6">
                        <SimplePieChart/>
                    </div>
                    <div className="col-md-6">
                    </div>
                </div>
            </div>

        );
    }
}

export default ChartsExample;


// WEBPACK FOOTER //
// ./web/src/components/charts/ChartsExample.jsx